export default __webpack_public_path__ + "static/media/l1Png.e9428e35.png";